const updates = [
  { date: '07-28', title: '《绝世武神》第358话更新', tag: '连载', tagColor: 'bg-primary-500' },
  { date: '07-28', title: '《甜蜜暴击》第142话上线', tag: '国漫', tagColor: 'bg-accent-500' },
  { date: '07-27', title: '《炎之轨迹》第98话发布', tag: '日漫', tagColor: 'bg-secondary-500' },
  { date: '07-27', title: '新作《暗夜侦探录》正式连载', tag: '新作', tagColor: 'bg-primary-500' },
  { date: '07-26', title: '《重生之都市仙尊》第210话', tag: '韩漫', tagColor: 'bg-accent-500' },
  { date: '07-26', title: '热门国漫专区新增30部作品', tag: '更新', tagColor: 'bg-secondary-500' },
  { date: '07-25', title: '《九天剑帝》第89话爆更', tag: '爆更', tagColor: 'bg-primary-500' },
  { date: '07-25', title: '日漫经典专区内容扩充', tag: '日漫', tagColor: 'bg-accent-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">更新动态</h2>
          <p className="text-sm text-foreground-500">最新漫画更新与平台动态速览</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={idx} className="flex items-start gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-primary-50/40 transition-colors -mx-2 px-2 rounded-lg">
              <div className="text-xs font-bold text-foreground-500 whitespace-nowrap pt-0.5">{item.date}</div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800">{item.title}</p>
              </div>
              <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-bold text-background-50 ${item.tagColor} whitespace-nowrap`}>{item.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}